import React from 'react'
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

const Estilos = StyleSheet.create({
    page: {
        fontSize: 10,
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 25,
        paddingRight: 25,
    },
    header: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 1,
        marginBottom: 10
    },
    emp_info: {
        display: "flex",
        width: "100%",
        padding: 8,
        flexDirection: "col",
        borderColor: "#bfbfbf",
        borderWidth: 1,
        textAlign: "center",
    },
    emp_info_title: {
        fontSize: "14",
        fontWeight: "800",
        borderWidth: 0,
        margin: 3
    },
    emp_info_detalle: {
        fontSize: "7",
        margin: 1
    },
    body: {
        padding: 3,
        borderColor: "#bfbfbf",
        borderWidth: 0,
        marginBottom: 5
    },
    body_oc: {
        justifyContent: "space-between",
        borderColor: "#bfbfbf",
        marginBottom: 8
    },
    body_oc_info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 3,
        width: "100%",
        borderWidth: 1,
        borderColor: "#bfbfbf",
    },
    body_oc_info_c1: {
        width: "50%",
    },
    body_oc_info_c2: {
        width: "50%",
    },
    sectionTitle: {
        fontSize: 10,
        fontWeight: "bold",
        marginBottom: 3,
        marginTop: 5
    },
    cell_etiqueta: {
        fontSize: 8,
        marginBottom: 1,
        fontWeight: "900",
        color: "#bfbfbf",
    },
    cell: {
        marginBottom: 1,
        color: "#58595d",
        fontSize: 8
    },
    body_detalle: {
        justifyContent: "space-between",
        borderColor: "#bfbfbf",
        borderWidth: 0,
        marginTop: 3
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeader: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: "#f0f0f0"
    },
    tableCol: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: 3,
        color: "#58595d",
        fontWeight: 500,
        fontSize: 8,
    },
    tableCell: {
        margin: 3,
        color: "#58595d",
        fontSize: 7,
    },
    footer: {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 1,
        marginTop: 8
    },
    footer_seccion_1: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 5
    },
    footer_seccion_2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 3
    },
    footer_seccion_2_seccion: {
        textAlign: "center",
        borderColor: "#bfbfbf",
        borderWidth: 1,
        fontSize: 7,
        width: "48%",
        height: 55,
        padding: 2
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 8,
        bottom: 15,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
});

const FIRST_PAGE_MAX_ITEMS = 36;
const OTHER_PAGE_MAX_ITEMS = 46;

function divideArray(inputArray) {
    let index = 0;
    let subArrays = [];

    if (inputArray.length > 0) {
        subArrays.push(inputArray.slice(index, index + FIRST_PAGE_MAX_ITEMS));
        index += FIRST_PAGE_MAX_ITEMS;
    }

    while (index < inputArray.length) {
        subArrays.push(inputArray.slice(index, index + OTHER_PAGE_MAX_ITEMS));
        index += OTHER_PAGE_MAX_ITEMS;
    }

    return subArrays;
}

function ReportePedidoProduccion(props) {
    const { pedido, detalles } = props;
    
    // Calcular totales
    const totalCantidad = detalles.reduce((sum, item) => sum + parseFloat(item.Cantidad || 0), 0);

    if (detalles.length > FIRST_PAGE_MAX_ITEMS) {
        const details = divideArray(detalles);
        const [first, ...rest] = details;

        return (
            <Document>
                <Page style={Estilos.page}>
                    <Header pedido={pedido}/>
                    <BodyInfo pedido={pedido} />
                    <DetalleTable detalles={first} showTotals={false} />
                    <PageNumber />
                </Page>

                {rest.map((d, index) => (
                    <Page style={Estilos.page} key={index}>
                        <DetalleTable detalles={d} showTotals={index === rest.length - 1} totalCantidad={totalCantidad} />
                        {index === rest.length - 1 && <Footer pedido={pedido} />}
                        <PageNumber />
                    </Page>
                ))}
            </Document>
        );
    }

    return (
        <Document>
            <Page style={Estilos.page}>
                <Header pedido={pedido}/>
                <BodyInfo pedido={pedido} />
                <DetalleTable detalles={detalles} showTotals={true} totalCantidad={totalCantidad} />
                <Footer pedido={pedido} />
                <PageNumber />
            </Page>
        </Document>
    );
}

// Componentes reutilizables
function Header({ pedido }) {
    return (
        <View style={Estilos.header}>
            <View style={Estilos.emp_info}>
                <Text style={Estilos.emp_info_title}>PEDIDO DE PRODUCCIÓN N° {pedido.IdPedidoProduccion}</Text>
                <Text style={Estilos.emp_info_detalle}>Sucursal: {pedido.NombreSucursal} | Usuario: {pedido.NombreUsuario}</Text>
            </View>
        </View>
    );
}

function BodyInfo({ pedido }) {
    return (
        <View style={Estilos.body}>
            <Text style={Estilos.sectionTitle}>Información del Pedido</Text>
            <View style={Estilos.body_oc}>
                <View style={Estilos.body_oc_info}>
                    <View style={Estilos.body_oc_info_c1}>
                        <Text style={Estilos.cell_etiqueta}>Fecha de Emisión:</Text>
                        <Text style={Estilos.cell}>{new Date(pedido.FechaEmision).toLocaleDateString()}</Text>
                        <Text style={Estilos.cell_etiqueta}>Estado:</Text>
                        <Text style={Estilos.cell}>{pedido.Estado}</Text>
                    </View>
                    <View style={Estilos.body_oc_info_c2}>
                        <Text style={Estilos.cell_etiqueta}>Fecha de Entrega:</Text>
                        <Text style={Estilos.cell}>{new Date(pedido.FechaEntrega).toLocaleDateString()}</Text>
                        <Text style={Estilos.cell_etiqueta}>Sucursal:</Text>
                        <Text style={Estilos.cell}>{pedido.NombreSucursal}</Text>
                    </View>
                </View>
            </View>
            <Text style={Estilos.sectionTitle}>Detalle del Pedido</Text>
        </View>
    );
}

function DetalleTable({ detalles, showTotals, totalCantidad }) {
    return (
        <View style={Estilos.body_detalle}>
            <View style={Estilos.table}>
                <View style={Estilos.tableRow}>
                    <View style={[Estilos.tableColHeader, {width: "6%", textAlign: "center"}]}>
                        <Text style={Estilos.tableCellHeader}>N°</Text>
                    </View>
                    <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                        <Text style={Estilos.tableCellHeader}>Código</Text>
                    </View>
                    <View style={[Estilos.tableColHeader, {width: "45%", textAlign: "left"}]}>
                        <Text style={Estilos.tableCellHeader}>Producto</Text>
                    </View>
                    <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                        <Text style={Estilos.tableCellHeader}>Cantidad</Text>
                    </View>
                    <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                        <Text style={Estilos.tableCellHeader}>Unidad</Text>
                    </View>
                    <View style={[Estilos.tableColHeader, {width: "13%", textAlign: "center"}]}>
                        <Text style={Estilos.tableCellHeader}>Categoría</Text>
                    </View>
                </View>
                {detalles.map((item, index) => (
                    <View key={item.IdDetallePP} style={Estilos.tableRow}>
                        <View style={[Estilos.tableCol, {width: "6%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "center"}]}>{index + 1}</Text>
                        </View>
                        <View style={[Estilos.tableCol, {width: "12%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "center"}]}>{item.Codigo}</Text>
                        </View>
                        <View style={[Estilos.tableCol, {width: "45%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "left"}]}>{item.NombreProducto}</Text>
                        </View>
                        <View style={[Estilos.tableCol, {width: "12%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "right"}]}>{parseFloat(item.Cantidad).toFixed(2)}</Text>
                        </View>
                        <View style={[Estilos.tableCol, {width: "12%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "center"}]}>{item.Descripcion}</Text>
                        </View>
                        <View style={[Estilos.tableCol, {width: "13%"}]}>
                            <Text style={[Estilos.tableCell, {textAlign: "center"}]}>{item.Categoria}</Text>
                        </View>
                    </View>
                ))}
                {showTotals && (
                    <View style={Estilos.tableRow}>
                        <View style={[Estilos.tableColHeader, {width: "63%", textAlign: "right"}]}>
                            <Text style={Estilos.tableCellHeader}>TOTAL GENERAL:</Text>
                        </View>
                        <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "right"}]}>
                            <Text style={Estilos.tableCellHeader}>{totalCantidad.toFixed(2)}</Text>
                        </View>
                        <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                            <Text style={Estilos.tableCellHeader}>-</Text>
                        </View>
                        <View style={[Estilos.tableColHeader, {width: "13%", textAlign: "center"}]}>
                            <Text style={Estilos.tableCellHeader}>-</Text>
                        </View>
                    </View>
                )}
            </View>
        </View>
    );
}

function Footer({ pedido }) {
    return (
        <View style={Estilos.footer} fixed>
            <View style={Estilos.footer_seccion_1}>
                <Text style={Estilos.cell_etiqueta}>Observaciones:</Text>
                <Text style={Estilos.cell}>{pedido.Observacion || 'Sin observaciones'}</Text>
            </View>
            <View style={Estilos.footer_seccion_2}>
                <View style={Estilos.footer_seccion_2_seccion}>
                    <Text>EMITIDO:</Text>
                    <Text>{'\n'}</Text>
                </View>
                <View style={Estilos.footer_seccion_2_seccion}>
                    <Text>ENTREGADO:</Text>
                    <Text>{'\n'}</Text>
                </View>
            </View>
        </View>
    );
}

function PageNumber() {
    return (
        <Text style={Estilos.pageNumber} render={({pageNumber, totalPages}) => (
            `${pageNumber} / ${totalPages}`
        )} fixed/>
    );
}

export default ReportePedidoProduccion;